import React from 'react';
import styled from '@emotion/styled';
import { format, getDay } from 'date-fns';
import Day from './Day';
import { WorkingDay } from '../../../../__generated__/graphql';
import { currentWeek, eachDayOfInterval } from '../../../../../../utils/date';
import { useCurrentLocale } from '../../../../../../context/I18n';
import { getDateFnsLocaleByString } from '../../../../../../utils/dateUtils';
import { dayOfWeekToWokingDay } from '../../../TimeSheetsControlling/CurrentTimeSheetsTab/TimeSheetEntryDaysWorked';

type Props = {
  workingDays: ReadonlyArray<WorkingDay>;
};

const Container = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

const WorkingDays: React.FC<React.PropsWithChildren<Props>> = ({
  workingDays,
}) => {
  const locale = useCurrentLocale();
  const dateFnsLocale = getDateFnsLocaleByString(locale);
  const days = eachDayOfInterval(currentWeek());

  return (
    <Container>
      {days.map((day) => {
        const label = format(day, 'EEE', { locale: dateFnsLocale });
        const variant = workingDays.includes(dayOfWeekToWokingDay(getDay(day)))
          ? 'workday'
          : 'non_workday';

        return <Day key={day.toISOString()} variant={variant} label={label} />;
      })}
    </Container>
  );
};

export default WorkingDays;
